















































































































import { Component, Prop, Model, Watch, Vue } from 'vue-property-decorator';
import ListeningItem from '../api/listeningItem';
import { MediaFileField } from '../models/fields';
import FieldImage from '@/components/FieldImage.vue';
import FieldAudio from '@/components/FieldAudio.vue';
import FieldInternational from './FieldInternational.vue';
import { BusEvent } from '@/models/bus';

@Component({
  components: {
    'field-image': FieldImage,
    'field-audio': FieldAudio,
    'field-international': FieldInternational
  }
})
export default class FieldListeningItem extends Vue {
  @Model('CorrectIndex', { type: Number }) public correctIndex!: number;

  @Prop({ type: ListeningItem }) public item!: ListeningItem;
  @Prop({ type: Boolean, default: false }) public disabled?: boolean;

  // used to upload media files
  @Prop({ type: String }) public parent_SLUG!: string;
  @Prop() public parent_id?: number;
  

  public IS_CORRECT = 1;
  public IS_FAILED = 0;
  public IS_INITIAL = -1;

  public checkAudio = this.IS_INITIAL;

  public currentIndex: number = this.correctIndex;

  public async beforeMount() {
    console.log('disabled', this.disabled);
  }

  @Watch('currentIndex')
  public setValue() {
    this.$emit('CorrectIndex', this.currentIndex);
  }

  @Watch('correctIndex')
  public updateValue() {
    this.currentIndex = this.correctIndex;
  }

  public checkMandatoryFields() {
    // Check if sentence was chosen
    if (this.item.sentence === undefined || this.item.sentence === '') {
      throw Error('Please select a sentence for item ' + (this.item.index + 1));
    }

    // Check if audio was chosen
    if (!((this.$refs.audio as any) as MediaFileField).hasMedia()) {
      throw Error(
        'Please select an audio file for item ' + (this.item.index + 1)
      );
    }

    // Check if image file was chosen
    // if(!((this.$refs.image as any) as MediaFileField).hasMedia()) {
    //     throw Error('Please select an image file for item ' + (this.item.index + 1));
    // }
  }

  public async saveMediaFiles(): Promise<void> {
    const image = await this.saveMediaFile(this.$refs.image, 'image');
    if (image !== null) {
      this.item.image_path = image;
    }
    const audio = await this.saveMediaFile(this.$refs.audio, 'audio');
    if (audio !== null) {
      this.item.audio_path = audio;
    }
    const audio_alt = await this.saveMediaFile(
      this.$refs.audio_alt,
      'audio_alt'
    );
    if (audio_alt !== null) {
      this.item.audio_alt_path = audio_alt;
    }
  }

  public async saveMediaFile(
    field: any,
    fieldName: string
  ): Promise<number | null | undefined> {
    if (!this.parent_id) {
      return null;
    }
    const mediaFileField = (field as any) as MediaFileField;

    if (mediaFileField.hasNewMedia()) {
      return await mediaFileField.upload(
        this.parent_SLUG,
        this.parent_id,
        fieldName
      );
    } else if (!mediaFileField.hasMedia()) {
      return undefined;
    } else {
      return null;
    }
  }

  public async checkAudioListening(): Promise<void> {
    this.disabled = true;
    try {
      this.checkMandatoryFields();
      const result = await this.item.checkAudioText(this.item);
      if (result && result.stream_score_type === 'correct') {
        this.checkAudio = this.IS_CORRECT;
        this.disabled = false;
      } else {
        this.checkAudio = this.IS_FAILED;
        this.disabled = false;
      }
    } catch (e) {
      this.disabled = false;
      this.$bus.$emit(BusEvent.ERROR, 'Could not check audio', e);
    }
  }
}
